export default __webpack_public_path__ + "static/media/logo.aeba318f.png";